import { markRaw, type Component } from 'vue'
import { useI18n } from 'vue-i18n'
import { mdiDomainPlus } from '@mdi/js'
import { useModal } from '@/apps/core'

/**
 * Opens the founding dialog the user drawer offers. Must be called at the top of a setup
 * function. Resolves when the dialog closes — on success, after the form has navigated to the
 * new organization.
 */
export function useFoundingModal() {
  const { open } = useModal()
  const { t } = useI18n()

  async function openFoundingModal(): Promise<void> {
    const { default: FoundingModal } = await import('../modals/FoundingModal.vue')
    await open(t('organizations.create.title'), markRaw(FoundingModal as Component), {
      width: '520px',
      icon: mdiDomainPlus,
      subtitle: t('organizations.create.modalSubtitle'),
    })
  }

  return { openFoundingModal }
}
